import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkbox']

  checkboxes() {
    this.checkboxTargets.forEach(t => {
      t.checked = true;
    });
  }
}
